var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"f0285cfa757f19c12a2ca7ffae5de1de7a42cba6"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/pkgtour/statics/vertical-v2/f0285cfa757f19c12a2ca7ffae5de1de7a42cba6";

import * as Sentry from '@sentry/nextjs';
import { env } from '@/lib/env';

const dsn = env('SENTRY_DSN');
const sampleRate = env('SENTRY_SAMPLE_RATE');
const environment = env('ENV') || process.env.NODE_ENV;

Sentry.init({
  release: process.env.GIT_COMMIT_HASH || undefined,
  dsn,
  sampleRate,
  environment,
  integrations: [Sentry.browserTracingIntegration()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for tracing.
  tracesSampleRate: sampleRate,

  // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
  tracePropagationTargets: [
    /^\//,
    /^https:\/\/(?:[a-zA-Z0-9-]*-)?pkgtour\.naver\.com/,
    /^https:\/\/(?:[a-zA-Z0-9-]*-)?pkgtour-v2\.naver\.com/,
  ],
});
